<template>
    <a class="cursor-pointer hover:underline">
        <slot/>
    </a>
</template>

<script>
export default {
  name: 'BaseLink',
  props: {
    colorType: {
      type: String,
      default: 'main',
      validator (value) {
        return ['main', 'secondary'].includes(value)
      }
    }
  },

  data () {
    return {
      classStyles: window.class_styles
    }
  }
}
</script>

<style scoped>

</style>
